export const ProposedSecondsToDeferUILevelSessionExpirationDuringActiveInteraction = 30;
